import { useDispatch, useSelector } from 'react-redux'
import { Checkbox } from '../../../../../common/html/checkbox'
import { changeListCheckedById, selectIsCheckedById } from '../../store/slice'

const CheckboxCell = ({ rowId }) => {
  const dispatch = useDispatch()

  const isChecked = useSelector(selectIsCheckedById(rowId))

  const handleClick = () => {
    dispatch(changeListCheckedById(rowId))
  }

  return (
    <div>
      <Checkbox
        styleIcon={{ fontSize: 13, paddingRight: 16 }}
        checked={isChecked}
        onChange={handleClick}
      />
    </div>
  )
}

export default CheckboxCell
